import { render, staticRenderFns } from "./Internal.vue?vue&type=template&id=3948ee34&scoped=true"
import script from "./Internal.js?vue&type=script&lang=js&external"
export * from "./Internal.js?vue&type=script&lang=js&external"
import style0 from "./Internal.scss?vue&type=style&index=0&id=3948ee34&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948ee34",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotHeader: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/Header/Header.vue').default,HotHeaderSidebar: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/HeaderSidebar/HeaderSidebar.vue').default,HotHero: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/Hero/Hero.vue').default,HotLegalBanner: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/LegalBanner/LegalBanner.vue').default,HotFooter: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/Footer/Footer.vue').default})
